import React, { useState } from 'react';
import styled, { css } from 'styled-components';

// components
import { ConversationHeader } from './ChatHeader';
import { LiveChat } from './LiveChat';
// forms
import { StartConversationForm } from './forms/StartConversationForm';
// types
import { User } from 'types';
// context
import { useSockets } from 'context/socket/SocketProvider';

const WidgetWrapper = styled.div<{ minimize: boolean }>`
  background: #ffffff;
  box-shadow: -8px -8px 80px rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  width: 360px;
  height: 460px;
  position: fixed;
  z-index: 12;
  padding: 0 24px 24px 24px;
  bottom: 32px;
  right: 32px;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100vh;
    top: 0px;
    bottom: unset;
    right: unset;
    ${({ minimize }) =>
      minimize &&
      css`
        height: 88px;
        bottom: 12px;
        top: unset;
        background: transparent;
        box-shadow: none;
        min-width: 360px;
        right: -6px;
      `}
  }
  ${({ minimize }) =>
    minimize &&
    css`
      height: 88px;
      background: transparent;
      box-shadow: none;
      width: auto;
      min-width: 360px;
      right: -6px;
    `}

  @media screen and (max-width: 520px) {
    padding: 0 16px 16px 16px;
  }
`;

const Paragraph = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  margin: 24px 0 0 0;
  margin-bottom: 16px;
  color: #09534a;
`;

const WelcomeMessage = styled.div`
  position: absolute;
  right: 100px;
  background: #ffffff;

  box-shadow:
    0px 0px 4px rgba(66, 79, 104, 0.08),
    0px 12px 20px rgba(66, 79, 104, 0.06);
  border-radius: 8px 8px 0px 8px;
  background-color: white;

  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.primary[100]};

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
`;

interface IConversation {
  advisorDetails: User;
  receiver: { phone: string | null; email: string | null };
}

//local storage utils
export const getItemFromLocalStorage = <T,>(key: string): T | undefined => {
  if (!localStorage) return undefined;
  const item = localStorage.getItem(key);
  if (item === null) {
    return undefined;
  }
  return JSON.parse(item) as T;
};

export const setItemToLocalStorage = (key: string, item: unknown) => {
  localStorage.setItem(key, JSON.stringify(item));
};

export const Conversations = ({ advisorDetails, receiver }: IConversation) => {
  const { currentConversation } = useSockets();
  const [minimize, setMinimize] = useState(true);
  const [unread, setUnread] = useState(false);

  const currentView = currentConversation?.conversationId;

  return (
    <WidgetWrapper minimize={minimize}>
      {minimize && !currentConversation?.conversationId && (
        <WelcomeMessage>
          Hi
          {receiver.email
            ? ` ${receiver.email}`
            : receiver.phone
              ? ` ${receiver.phone}`
              : ''}
          , how can i help you?
        </WelcomeMessage>
      )}
      <ConversationHeader
        advisorDetails={advisorDetails}
        minimize={minimize}
        setMinimize={setMinimize}
        unread={unread}
        setUnread={setUnread}
      />
      {currentView === undefined ? (
        <div style={{ display: minimize ? 'none' : 'block' }}>
          <Paragraph>Please, confirm your contact info</Paragraph>
          <StartConversationForm
            receiver={receiver}
            userId={advisorDetails.id}
          />
        </div>
      ) : (
        <LiveChat
          advisorDetails={advisorDetails}
          userId={advisorDetails.id}
          minimize={minimize}
          setUnread={setUnread}
        />
      )}
    </WidgetWrapper>
  );
};
